import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../state/reducers';
import { AssetHit } from '../../../../api/vault/searchEngine/interfaces';
import {
  IProps,
  IState,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  closePrePostRollSelection,
  ROLL,
} from '../../../VirtualClipper/state/prePostRollSelection';
import { setPrePostRoll, removePrePostRoll } from '../../../../state/selectedClipsPreview';
import VaultButton from '../../VaultButton';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogContentContainer,
  DialogActionsOverride,
  ActionContainer,
} from '../../styles/dialog';
import { ListContainer } from './styles';
import PrePostRollList from '../PrePostRollList/component';

class PrePostRollSelection extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const {
      selectionType,
      selectedPreRoll,
      selectedPostRoll,
    } = props;

    const selectedPrePostRoll = selectionType === ROLL.PRE ? selectedPreRoll : selectedPostRoll;
    this.state = {
      selectedItem: !selectedPrePostRoll ? null : selectedPrePostRoll.asset,
    };
  }

  handleItemSelect = (selectedItem: AssetHit) => {
    this.setState({
      selectedItem,
    });
  };

  handleApply = () => {
    const {
      selectionType,
      setPrePostRollConnect,
      removePrePostRollConnect,
      closePrePostRollSelectionConnect,
    } = this.props;
    const { selectedItem } = this.state;

    if (!selectedItem) {
      removePrePostRollConnect(selectionType);
    } else {
      setPrePostRollConnect(selectionType, selectedItem);
    }

    closePrePostRollSelectionConnect();
  };

  render() {
    const {
      selectionType,
      closePrePostRollSelectionConnect,
    } = this.props;

    const { selectedItem } = this.state;

    return (
      <>
        <DialogHeader>
          <DialogHeaderTitle>
            {`Select ${selectionType === ROLL.PRE ? 'Pre' : 'Post'}roll`}
          </DialogHeaderTitle>
        </DialogHeader>
        <DialogContentContainer>
          <ListContainer>
            <PrePostRollList
              selectedItem={selectedItem}
              onItemSelect={this.handleItemSelect}
            />
          </ListContainer>
        </DialogContentContainer>
        <DialogActionsOverride disableSpacing>
          <ActionContainer>
            <VaultButton
              variant="plainOnPaper"
              onClick={closePrePostRollSelectionConnect}
            >
              Cancel
            </VaultButton>
            <VaultButton
              variant="primaryOnWhite"
              onClick={this.handleApply}
            >
              Apply
            </VaultButton>
          </ActionContainer>
        </DialogActionsOverride>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  selectionType: state.prePostRollSelection.selectionType,
  selectedPreRoll: state.selectedClipsPreview.preRoll,
  selectedPostRoll: state.selectedClipsPreview.postRoll,
});

const mapDispatchToProps: IDispatchProps = {
  closePrePostRollSelectionConnect: closePrePostRollSelection,
  setPrePostRollConnect: setPrePostRoll,
  removePrePostRollConnect: removePrePostRoll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrePostRollSelection);
